import { HealthBadge } from "./ui";

function project(lat, lng) {
  const x = ((Number(lng) + 180) / 360) * 100;
  const y = ((90 - Number(lat)) / 180) * 100;
  return { x, y };
}
const DOT = { optimal: "#10B981", warning: "#F59E0B", critical: "#EF4444" };

export default function WorldMap({ cities = [], onSelect }) {
  const withCoords = cities.filter((c) => c.lat != null && c.lng != null);
  return (
    <div className="rounded-xl bg-[#0B0F19] border border-white/10 overflow-hidden">
      <div className="relative w-full" style={{ paddingBottom: "45%", background: "radial-gradient(ellipse at center, #0f1a2e 0%, #0B0F19 80%)" }}>
        <div className="absolute inset-0 grid-glow opacity-30" />
        {/* latitude/longitude guide lines */}
        <div className="absolute left-0 right-0 top-1/2 h-px bg-white/5" />
        <div className="absolute top-0 bottom-0 left-1/2 w-px bg-white/5" />
        {withCoords.map((c) => {
          const { x, y } = project(c.lat, c.lng);
          const color = DOT[c.health] || DOT.optimal;
          return (
            <button key={c.city_id || c.name} data-testid={`map-pin-${c.name}`} onClick={() => onSelect && onSelect(c)}
              className="absolute -translate-x-1/2 -translate-y-1/2 group" style={{ left: `${x}%`, top: `${y}%` }} title={`${c.name} · ${c.total_workers} workers`}>
              <span className="absolute inset-0 rounded-full animate-ping" style={{ background: color, opacity: 0.4, width: 14, height: 14, marginLeft: -7, marginTop: -7 }} />
              <span className="relative block rounded-full ring-2 ring-white/20" style={{ background: color, width: 12, height: 12 }} />
              <span className="absolute left-1/2 -translate-x-1/2 mt-1 whitespace-nowrap text-[10px] font-semibold text-white bg-black/60 px-1.5 py-0.5 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                {c.name} · {c.total_workers}
              </span>
            </button>
          );
        })}
      </div>
      <div className="p-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-3 max-h-64 overflow-y-auto cc-scroll">
        {cities.map((c) => (
          <button key={c.city_id || c.name} data-testid={`map-city-card-${c.name}`} onClick={() => onSelect && onSelect(c)}
            className="text-left p-3 rounded-lg bg-[#151D2A] border border-white/10 hover:border-[#1D4ED8]/50 transition-colors">
            <div className="flex items-center justify-between">
              <span className="font-semibold text-white text-sm">{c.name}</span>
              <HealthBadge health={c.health} />
            </div>
            <div className="mt-2 grid grid-cols-3 gap-1 text-center">
              <div><div className="font-mono-metric text-sm font-bold text-white">{c.total_workers}</div><div className="text-[9px] text-slate-500 uppercase">Workers</div></div>
              <div><div className="font-mono-metric text-sm font-bold text-emerald-400">{c.online_workers}</div><div className="text-[9px] text-slate-500 uppercase">Online</div></div>
              <div><div className="font-mono-metric text-sm font-bold text-[#1D4ED8]">{c.completion_rate}%</div><div className="text-[9px] text-slate-500 uppercase">Tasks</div></div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
